import React from 'react';

import ActionTileView from '../ActionTile.View';
import {AnalysisActionModel} from './AnalysisAction.model';

export default React.memo(function AnalysisActionView({
  on,
  label,
  hint,
  disabled,
  onPress,
}: AnalysisActionModel) {
  return (
    <ActionTileView
      testID="v2-action-analysis"
      icon="bulb"
      label={label}
      hint={hint}
      active={on}
      disabled={disabled}
      onPress={onPress}
    />
  );
});
